import { $switchCaseStrict } from 'dolla-switch';
import { fetchJson } from '../utils/http';
import { PermissionValue } from '../utils/permissions';
const getRequestPermission = permission => $switchCaseStrict(permission, {
  [PermissionValue.CAN_VIEW]: () => 'viewer',
  [PermissionValue.CAN_COMMENT]: () => 'commenter',
  [PermissionValue.CAN_EDIT]: () => 'editor'
});
export const getCollaborators = documentOid => fetchJson(`/api/v1/share/${documentOid}/permissions/?include_organization_permission=1&hide_collaborators_name=1&include_pending_invites=1`);
export const updateCollaborator = (documentOid, email, permission, referralToken) => {
  let url = `/api/v1/share/${documentOid}/permissions/`;
  if (referralToken) {
    url += `?referral_token=${encodeURIComponent(referralToken)}`;
  }
  return fetchJson(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: email.toString(),
      permission: getRequestPermission(permission),
      trigger_organic_invitation_if_needed: true
    })
  }).then(resp => {
    if (Array.isArray(resp) && resp[0] && resp[0].email) {
      return resp[0];
    } else if (resp.email) {
      return resp;
    }
    throw 'Invalid response shape';
  });
};
export const deleteCollaborator = (documentOid, email) => fetch(`/api/v1/share/${documentOid}/permissions/`, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    email: email.toString(),
    trigger_organic_invitation_if_needed: true
  })
});
export const updateTeamPermission = (documentOid, permission) => fetchJson(`/api/v1/share/${documentOid}/organization-permission/`, {
  method: 'PUT',
  body: JSON.stringify(getRequestPermission(permission))
});
export const deleteTeamPermission = documentOid => fetch(`/api/v1/share/${documentOid}/organization-permission/`, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json'
  }
});